/**
 * vukz_locale — persistência do idioma do site público VUKZ.
 * Resolução: URL/rota → preferência salva → idioma do navegador → 'en'.
 */
const KEY = 'vukz_locale';
const SUPPORTED = ['pt', 'en'];

export const getSavedLocale = () => {
  try {
    const v = localStorage.getItem(KEY);
    return SUPPORTED.includes(v) ? v : null;
  } catch { return null; }
};

export const saveLocale = (locale) => {
  if (!SUPPORTED.includes(locale)) return;
  try { localStorage.setItem(KEY, locale); } catch { /* noop */ }
};

export const getBrowserLocale = () => {
  const nav = (navigator.language || '').toLowerCase();
  return nav.startsWith('pt') ? 'pt' : 'en';
};

/** routeLocale: locale imposto pela URL (maior prioridade), ou null. */
export const resolveLocale = (routeLocale) => {
  if (SUPPORTED.includes(routeLocale)) return routeLocale;
  return getSavedLocale() || getBrowserLocale();
};
